import { loadStripe as _loadStripe } from '@stripe/stripe-js'
import config from '../config'
export const loadStripe = _loadStripe(config.STRIPE_PK)
